import React, { createContext, useEffect, useRef } from 'react';
import { useSnapshot } from 'valtio';
import { sessionState, updateToken } from './sessionState';
import { useLoading } from './LoadingProvider'; 

// Create the context
export const TokenSessionContext = createContext();

// SessionProvider component
export function TokenSessionProvider({ children, config = {} }) {
  const snapshot = useSnapshot(sessionState);
  const { startLoading, stopLoading } = useLoading();
  const processedRef = useRef(false); // Track if we've already processed the URL params
  
  useEffect(() => {
    // Only process once
    if (processedRef.current) {
      return;
    }
    
    processedRef.current = true;
    
    // Create a loader ID when the component mounts
    const loaderId = startLoading();
    
    // Extract token and cardId from URL on initial load
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const cardId = urlParams.get('cardId');
    const channel = urlParams.get('channel');
    const endpointId = urlParams.get('endpointId');
    const sub = urlParams.get('sub'); // encoded user id, when present we need to use cookie authentication
    
    if (token || sub) {
      // Use the function to update token and refresh session
      updateToken(token, cardId, sub, channel, endpointId)
        .finally(() => {
          // Always stop loading when updateToken completes, whether successful or not
          stopLoading(loaderId);
        });
    } else {
      console.warn('No token provided in the URL');
      sessionState.isLoading = false;
      sessionState.demoData.enabled = true;
      // Stop loading if no token is provided
      stopLoading(loaderId);
    }
    
    // Clean up the loader if the component unmounts during loading
    return () => {
      stopLoading(loaderId);
    };
  }, []); 
  
  // Only render children if not loading
  if (snapshot.isLoading) {
    return null; // Or return a loading indicator
  }
  
  return (
    <TokenSessionContext.Provider value={{ session: snapshot }}>
      {children}
    </TokenSessionContext.Provider>
  );
}